export default class Service {
  
  constructor( api, alias ) {
    this.api = api
    this.connect = api.child( 'service' ).child( alias )
  }

  /**
   * Gets the Service. 
   * @param {object} data
   * @param {array<string>} data.attributes the fields to include in result
   * @param {boolean} data.includeRoutes if false, routes are not included
   * 
   **/
  get( data ) {
    return this.connect.get( data )
  }

  /**
   * Returns the current version
   */
  async version( ) {
    const s = await this.get( { attributes : [ 'version' ], includeRoutes : false } )
    return s.version
  }

  /**
   * Updates the Service
   * @param {object} data
   * @param {int} data.version the new version value
   * @param {string} data.alias the new alias value
   * @param {string} data.name the new name value
   * @param {string} data.description the new description value
   * @param {array<routes>} data.routes the routes
   * @param {boolean} data.replaceRoutes if true, all current routes are removed.
   * If true, the updated routes must include their id.
   */
  update( data ) {
    return this.connect.patchRaw( data )
  }

  /**
   * Removes the Service
   */
  remove( ) {
    return this.connect.delete( )
  }
}
